import React,{Component} from 'react';
import { IonLoading } from '@ionic/react';

import './ForgotPassword.css';

// components

// methods
import { loginBackground, logo } from '../../_utils/images';
import classNames from 'classnames';
import { API_URL } from '../../_utils/config';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Message from '@acri-tools/react-tools/components/Message/Message';
import request from '@acri-tools/react-tools/utils/request';
import { push_history } from '@acri-tools/react-tools/utils/global';

interface MyProps{
    history?:any,

    // setToasts?:any
}

class ForgotPassword extends Component<MyProps,{}>{
    state={
        loading: false,
        email:'',
        message: '',
        messageType: 'warn'
    }
    render(){
        return (
            <Page 
                id="forgot-password"
                topBar={{
                    routes: routes,
                    logo: logo,
                }}
            >
                <IonLoading
                    isOpen={this.state.loading}
                    message={'Sending password reset...'}
                />
                <div 
                    className="page-content"
                    style={{
                        backgroundImage:`url(${loginBackground})`
                    }}
                >
                    <div id="login-container" className="form-container">
                        <div className="form">
                            <div className="form-field large">
                                <label>
                                    Email
                                </label>
                                <input 
                                    type="email" value={this.state.email} placeholder={"Email"}
                                    onKeyDown={this.onEnter} onChange={(e)=>{ this.inputTyped(); this.setState({email:e.target.value}); }}/>
                            </div>
                            
                            <Message message={ this.state.message } type={ this.state.messageType }/>
                        </div>
                        
                        <br/>

                        <div className="custom-button forgot" onClick={this.send}> <i className="fas fa-paper-plane"/> SEND RESET </div>
                        <h2 className="divider"><div className="line"/><span>I REMEMBER MY LOGIN</span><div className="line"/></h2>
                        <div className="login-alt">
                            <div className="custom-button inverted login" onClick={()=>{ push_history('/login') }}>
                                <i className="fas fa-sign-in-alt"/>
                                LOGIN
                            </div>
                        </div>
                    </div>  
                </div>
            </Page>
        );
    }

    inputTyped = () =>{
        this.setState({
            message: ''
        })
    }
    onEnter = (e:any) =>{
        if(e.keyCode === 13){
            this.send();
        }
    }

    send = async() =>{
        if(!this.state.email){
            console.log("gdfgdfgdf");
            this.setState({
                message: 'Missing Email',
                messageType: 'warn'
            })
            // this.props.setToasts({alert:true,alertMessage:`Username and password are required.`,alertHeader:"Warning"});
        }
        else{
            this.setState({ loading:true });
            
            request(`${API_URL}/api/user-manager/v1/forgotPassword`,{
                method:'post',
                data:{
                    email:this.state.email
                },
            })
            .then((res)=>{
                this.setState({ loading:false });
                // this.props.setToasts({alert:true,alertMessage:`Successfully sent password reset to email ${this.state.email}`,alertHeader:"Success"});
                // this.props.setToasts({active:true,message:"Successfully sent password reset"});
                push_history('/login')
            })
            .catch(e=>{;
                this.setState({loading:false});
                // console.log("e.response",e.response);
                this.setState({
                    message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                    messageType: 'error'
                })
                // axiosErrorHandler(e,'FORGOT_PASSWORD',undefined,'An error has occured, try again later');
            })
        }
    }
};


export default ForgotPassword;
